import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";
import {ConsonantComplex} from "../../../SubjectData/Phonetics/Phonetics.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";


export default function ConsonantComplexDeck() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantsNav"}/>
        <FlashcardInterface deckData={ConsonantComplex} title="Complex (Double) Consonants" />
     </>
);}

//resource: https://dev.to/gbadeboife/build-a-flashcard-quiz-with-react-49gi